import { render, staticRenderFns } from "./FactorsStep.vue?vue&type=template&id=5c98c4fe&scoped=true&"
import script from "./FactorsStep.vue?vue&type=script&lang=js&"
export * from "./FactorsStep.vue?vue&type=script&lang=js&"
import style0 from "./FactorsStep.vue?vue&type=style&index=0&id=5c98c4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98c4fe",
  null
  
)

export default component.exports